module.exports = __webpack_public_path__ + "static/img/09.bd23cbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/rz/09.jpg
// module id = fpI6
// module chunks = 0